import React from 'react';
import { Building2, Users, TrendingUp, MapPin, Award } from 'lucide-react';
export function QuickFacts() {
  const facts = [{
    icon: <Building2 className="w-5 h-5 text-blue-600" data-id="element-75" />,
    label: 'Gegründet',
    value: '2020',
    sub: 'Justus Kraft'
  }, {
    icon: <Users className="w-5 h-5 text-blue-600" data-id="element-76" />,
    label: 'Kundenbasis',
    value: '110+',
    sub: 'Unternehmen'
  }, {
    icon: <TrendingUp className="w-5 h-5 text-blue-600" data-id="element-77" />,
    label: 'Zusätzlicher Umsatz',
    value: '€7M+',
    sub: 'Für Kunden'
  }, {
    icon: <Award className="w-5 h-5 text-blue-600" data-id="element-78" />,
    label: 'Spezialisierung',
    value: 'Close CRM',
    sub: 'Implementierung'
  }, {
    icon: <MapPin className="w-5 h-5 text-blue-600" data-id="element-79" />,
    label: 'Standort',
    value: 'Deutschland',
    sub: 'DSGVO-konform'
  }];
  return <section className="py-12 bg-white" data-id="element-80">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <h2 className="text-xl font-bold text-slate-900 mb-6" data-id="element-82">
          Schnelle Fakten
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-83">
          {facts.map((fact, index) => <div key={index} className="p-4 rounded-lg border border-slate-100 bg-slate-50 hover:border-blue-100 transition-colors" data-id="element-84">
              <div className="mb-3 p-2 bg-white rounded-md inline-block shadow-sm border border-slate-100" data-id="element-85">
                {fact.icon}
              </div>
              <div className="font-bold text-slate-900 text-lg" data-id="element-86">
                {fact.value}
              </div>
              <div className="text-sm font-medium text-slate-700" data-id="element-87">
                {fact.label}
              </div>
              <div className="text-xs text-slate-500 mt-1" data-id="element-88">{fact.sub}</div>
            </div>)}
        </div>
      </div>
    </section>;
}